import axios from 'axios'
import TokenService from '@/services/storage.service'
import { store } from '@/store'

const ApiService = {

    _401interceptor: null,

    init(baseURL) {
        axios.defaults.baseURL = baseURL
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },

    
    removeHeader() {
        axios.defaults.headers.common = {}
    },
    
    setUploadHeader() {
        axios.defaults.headers.post['contentType'] = 'multipart/form-data';
        
        // console.log(axios.defaults); alert(1);
    },

    removeUploadHeader() {
        axios.defaults.headers.contentType = ''
    },

    get(resource) {
        return axios.get(resource)
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        // console.log(axios.defaults);
        // alert(1);
        return axios(data)
    },

    mount401Interceptor() {
        this._401interceptor = axios.interceptors.response.use(
            (response) => {
                return response
            },
            async (error) => {
                if (error.request.status == 401) {
                    if (error.config.url.includes('/o/token')) {
                        store.dispatch('auth/logout')
                        throw error
                    } else {
                        try{
                            await store.dispatch('auth/refreshToken')
                            return this.customRequest({
                                method: error.config.method,
                                url: error.config.url,
                                data: error.config.data
                            })
                        } catch (e) {
                            throw error
                        }
                    }
                }
                throw error
            }
        )
    },

    unmount401Interceptor() {
        axios.interceptors.response.eject(this._401interceptor)
    }
}

export default ApiService